import { render, staticRenderFns } from "./ServiceCardIcon.vue?vue&type=template&id=5a2ca14c&scoped=true&"
import script from "./ServiceCardIcon.vue?vue&type=script&lang=js&"
export * from "./ServiceCardIcon.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCardIcon.vue?vue&type=style&index=0&id=5a2ca14c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2ca14c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
